import PricingSwitcher from "./PricingSwitcher";
import createClient from '../Client';
import { useState, useEffect } from "react";


const pricingSwitcherLAbel = [
    {
        label :'Monthly'
    }, 
    {
        label :'Yearly'
    }
]

//Pricing block wrapper
const Pricing = () => {

    const[pricingData, setpricingData] = useState([]);

    useEffect(() => {
      createClient.fetch(`*[_type == 'prices' && !(_id in path('drafts.**'))] | order(_createdAt asc){
        ...,
            "dataMonthly":{

            "switcher":'monthly',
            "headName":prices_title,
            "headPrice":prices_monthly_amount,
            "headBasis":'per month',
            "featureLIst":prices_monthly_plan_features,
            "buttonText":prices_monthly_button.prices_monthly_button_label,
            "buttonLink":prices_monthly_button.prices_monthly_button_link,
            ...,
        },
        "dataYearly":{
            "switcher":'yearly',
            "headName":prices_title,
            "headPrice":prices_yearly_amount,
            "headBasis":'per year',
            "featureLIst":prices_yearly_plan_features,
            "buttonText":prices_yearly_button.prices_button_label,
            "buttonLink":prices_yearly_button.prices_button_link,
            ...,
        }
        }`).then((data) => {
            setpricingData(data);
        })
      .catch(console.error);
  },[])


    return(
      <>
        <section className="pricing bg-clouds-red p-top-70">
            <div className="container">
                <PricingSwitcher pricingSwitcherLAbel={pricingSwitcherLAbel} pricingSwitcherContent={pricingData}></PricingSwitcher>
            </div>
        </section>
      </>
    );
}
  
export default Pricing;

